import styled, { css } from 'styled-components'
import { SecondaryButton } from '@chegg-ui/button'
import { colors, spacing, breakpoints } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'

export const LogoContainer = styled.div`
  display: flex;
`
export const LogoLink = styled.a``

export const Logo = styled.img`
  display: inline-block;
  position: relative;
  width: auto;
  height: 30px;
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  padding: 20px ${spacing.px48};
  @media (max-width: ${breakpoints.md.max}) {
    padding: ${spacing.px12} ${spacing.px16};
  }
`
export const LeftNavItems = styled.div`
  display: flex;
  align-items: center;
`
export const RightNavItems = styled.div`
  display: flex;
  align-items: center;
`
export const NavItems = styled.div`
  display: flex;
  margin-left: ${spacing.px32};
  gap: ${spacing.px32};
`

export const FooterWrapper = styled.div``

export const NavItem = styled(SecondaryButton).attrs({
  variant: 'text',
  size: 'medium',
})<{ hideOnMobile: boolean }>`
  display: none;

  ${({ hideOnMobile }) =>
    hideOnMobile &&
    css`
      @media (min-width: ${breakpoints.md.max}) {
        display: inline-block;
        && {
          color: ${colors.dark};
          line-height: 20px;
          letter-spacing: 0.3px;
          :hover {
            background: none;
          }
        }
      }
    `}
`

export const MenuButton = styled.div`
  padding: ${spacing.px4};
  margin-right: ${spacing.px8};
  @media (min-width: ${breakpoints.md.max}) {
    display: none;
  }
`
export const RightNavMobileItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.px8};
  @media (min-width: ${breakpoints.md.max}) {
    display: none;
  }
`
export const CountryCode = styled(Typography).attrs({
  variant: 'h6',
  variantType: 'heavy',
})`
  display: flex;
  align-items: center;
  gap: ${spacing.px4};
`
